module.exports = __webpack_public_path__ + "static/3-1190843bba38944448fc7f2e603ac1be.jpg";